import SSView from 'core/src/views/base/ss-view';
import PageOverlay from 'core/src/views/modules/page-overlay';

const SlideOverView = SSView.extend({

  className: 'slideover',
  setElementToTemplate: true,
  visibleEl: null,

  initialize: function(options = {}) {
    _.bindAll(this, 'onAnchorClick', 'onClickClose', 'onBodyClick', 'resize');
    _.extend(this, _.pick(options, ['anchor']));

    this.anchor.on('click', this.onAnchorClick);

    this.anchor.addClass('initialized');

    this.autoRender = true;

    SSView.prototype.initialize.apply(this, arguments);
  },

  render: function() {
    SSView.prototype.render.apply(this, arguments);

    $('#page-wrapper').append(this.$el);

    this.width = this.$el.width();
    this.$el.css({
      'right': `-${this.width}px`,
    });

    this.resize();
    window.addEventListener('scroll', this.resize);
    window.addEventListener('resize', this.resize);

    this.contentEl = this.$('.content');
    this.closeButton = this.$('.btn-close');
    this.closeButton.on('click', this.onClickClose);
  },

  resize: function() {
    let header = $('.site-header');
    if (header.hasClass('sticky-bottom')) {
      header = $('.fixed-header');
    }

    if (!_.isUndefined(header[0])) {
      const { bottom } = header[0].getBoundingClientRect();
      this.$el.css({
        'height': $(window).height() - bottom,
      });
    }
  },

  open: function() {
    this.$el.show();
    this.visibleEl = this.$el;
    this.resize();

    this.$el.animate({
      'right': '0',
    }, 300);

    this.anchor.addClass('open');
    this.anchor.addClass('was-shown');

    // we only want to bind this event once
    $('body').off('click', this.onBodyClick)
      .on('click', this.onBodyClick);

    this.trigger('slideover:open', { slideoverEl: this.visibleEl });
    $('#bell-icon-nav').removeClass('bell-default');
    $('#bell-icon-nav').addClass('bell-active');
    $('.site-header').addClass('visible-header');

    PageOverlay.open();

    $('#click-off-overlay').addClass('slide-over-background');
  },

  close: function() {
    this.$el.animate(
      { 'right': `-${this.$el.width()}px` },
      300,
      'swing',
      () => {
        this.$el.hide();
        this.visibleEl = null;
      }
    );

    this.anchor.removeClass('open');
    this.trigger('slideover:close');
    PageOverlay.close();
    $('#bell-icon-nav').addClass('bell-default');
    $('#bell-icon-nav').removeClass('bell-active');
  },

  isOpen: function() {
    return !_.isNull(this.visibleEl);
  },

  onAnchorClick: function(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    if (this.isOpen()) {
      this.close();
    } else {
      this.open();
    }
  },

  onBodyClick: function(ev) {
    // don't close when clicking the anchor
    if (this.anchor.get(0) === ev.target) {
      return;
    }

    // don't close when clicking any of the anchor's child elements
    if (this.anchor.has(ev.target).length > 0) {
      return;
    }

    // don't close when clicking any of the slideover's child elements
    if (!_.isNull(this.visibleEl) && this.visibleEl.has(ev.target).length > 0) {
      return;
    }

    if (this.isOpen()) {
      this.close();
    }
  },

  onClickClose: function(ev) {
    ev.preventDefault();
    this.close();
  },
});

export default SlideOverView;

